"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signDocument = exports.getDocuments = exports.generateZakatStatement = exports.downloadPortfolioOverviewDocument = exports.downloadPerformanceOverviewDocument = exports.downloadInvestmentStatementDocumentV2 = exports.downloadInvestmentStatementDocument = void 0;
const downloadInvestmentStatementDocument = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/documents/commitment-overview`, data, {
  withCredentials: true
});
exports.downloadInvestmentStatementDocument = downloadInvestmentStatementDocument;
const downloadInvestmentStatementDocumentV2 = (serverURL, appAxios) => async (data, onDownloadProgress) => await appAxios.post(`${serverURL}/documents/commitment-overview-v2`, data, {
  withCredentials: true,
  responseType: "blob",
  onDownloadProgress
});
exports.downloadInvestmentStatementDocumentV2 = downloadInvestmentStatementDocumentV2;
const downloadPerformanceOverviewDocument = (serverURL, appAxios) => async (data, onDownloadProgress) => await appAxios.post(`${serverURL}/documents/performance-overview`, data, {
  withCredentials: true,
  responseType: "blob",
  onDownloadProgress
});
exports.downloadPerformanceOverviewDocument = downloadPerformanceOverviewDocument;
const downloadPortfolioOverviewDocument = (serverURL, appAxios) => async (data, onDownloadProgress) => await appAxios.post(`${serverURL}/documents/portfolio-overview`, data, {
  withCredentials: true,
  responseType: "blob",
  onDownloadProgress
});
exports.downloadPortfolioOverviewDocument = downloadPortfolioOverviewDocument;
const generateZakatStatement = (serverURL, appAxios) => async () => await appAxios({
  url: `${serverURL}/documents/zakat-statement`,
  method: "POST",
  responseType: "arraybuffer",
  withCredentials: true
});
exports.generateZakatStatement = generateZakatStatement;
const getDocuments = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/documents`, {
  withCredentials: true
});
exports.getDocuments = getDocuments;
const signDocument = (serverURL, appAxios) => async documentId => await appAxios.get(`${serverURL}/documents/sign/${documentId}`, {
  withCredentials: true
});
exports.signDocument = signDocument;